import { useEffect } from "react";
import swal from "sweetalert";
import { services } from "../../../studentportal-sdk";
import { history } from "../../../_components/_helpers/history";

export const UtilityAndConfig = (props) => {
  const _utilAndConfigService = services.utilityAndConfig(props);


  const role = localStorage.getItem("role");

  // utilAndConfig service
  const {
    store: { message, loading },

    action: { clearMessage, stopAllLoadingProccess },
  } = _utilAndConfigService;

  

  /**
   * handle message alert
   */
  useEffect(() => {
    // display message
    message.show &&
      swal({
        title: message.title,
        text: message.description,
        icon: message.type,
        button: "ok",
      });

    // hide message
    message.show &&
      setTimeout(() => {
        clearMessage();
        // window.location.reload()
      }, 5000);

    message.type === "success" &&
      !["/viewassessment", "/admindashboard", "/userdashboard"].includes(
        history.location.pathname
      ) &&
      setTimeout(() => {
        clearMessage();
        window.location.reload();
      }, 3000);
  }, [message.show ]);

  /**
   * handle loading
   */
  useEffect(() => {
    loading.proccessesCount === 0 && loading.active && stopAllLoadingProccess();
  }, [loading.proccessesCount]);

  useEffect(() => {
    if (!role && !["/login", "/register", "/forgot-password", "/resetpassword"].includes(
        history.location.pathname
      )) {
         window.location.href = "/login"; // Use `=` to set the URL.
      } 
  }, []);


  return {
    utilityAndConfigService: {
      ..._utilAndConfigService,
    },
    ...props,
  };
};
